import React, { FC } from "react";
import { Button, Modal, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";

type ConfirmSubmissionModalStageProps = {
  open: boolean;
  title: string;
  handleCancel: () => void;
  handleSave: () => void;
  isLoading?: boolean;
  content?: any;
  mappings?: Array<{
    originalColumnName: string;
    mappedColumnName: string;
    targetTableName?: string | null;
    seqNo?: number | null;
  }>;
  width?: any;
};

const { Text } = Typography;

const ConfirmSubmissionModalStage: FC<ConfirmSubmissionModalStageProps> = (
  props
) => {
  return (
    <Modal
      open={props?.open}
      onCancel={props?.handleCancel}
      footer={null}
      closable={false}
      bodyStyle={{ textAlign: "center" }}
      width={props?.width ? props?.width : props?.content ? 5000 : 520}
      zIndex={2500}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid rgb(0, 76, 143)",
          borderRadius: "50%",
          padding: "6px",
          boxShadow: "0 24px 24px rgba(0, 0, 0, 0.15)",
          backgroundColor: " #ffffff",
          marginBottom: "8px",
        }}
      >
        <CheckOutlined style={{ fontSize: "14px", color: "rgb(0, 76, 143)" }} />
      </div>
      <Title level={4} style={{ marginTop: 16 }}>
        CONFIRM
      </Title>
      <Text
        style={{ display: "block", marginBottom: 24, whiteSpace: "pre-line" }}
      >
        {props?.title}
      </Text>
      {props.content && (
        <div style={{ marginBottom: 24 }}>{props.content}</div>
      )}
      {props.mappings && props.mappings?.length > 0 && (
        <div style={{ marginBottom: 24, textAlign: "left" }}>
          <Title level={5} style={{ marginBottom: 8 }}>Selected Mappings</Title>
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 8, height: '300px', overflowY: 'auto', display: 'block' }}>
            <thead>
              <tr style={{ background: "#f0f4fa" }}>
                <th style={{ padding: "6px", border: "1px solid #e0e0e0" }}>Hospital Column</th>
                <th style={{ padding: "6px", border: "1px solid #e0e0e0" }}>Mapped DB Column</th>
                {/* <th style={{ padding: "6px", border: "1px solid #e0e0e0" }}>Target Table</th> */}
                {/* <th style={{ padding: "6px", border: "1px solid #e0e0e0" }}>Sequence No.</th> */}
              </tr>
            </thead>
            <tbody>
              {props.mappings?.map((m, idx) => (
                <tr key={m.originalColumnName + idx}>
                  <td style={{ padding: "6px", border: "1px solid #e0e0e0" }}>{m.originalColumnName}</td>
                  <td style={{ padding: "6px", border: "1px solid #e0e0e0" }}>{m.mappedColumnName}</td>
                  {/* <td style={{ padding: "6px", border: "1px solid #e0e0e0" }}>{m.targetTableName || '-'}</td> */}
                  {/* <td style={{ padding: "6px", border: "1px solid #e0e0e0" }}>{m.seqNo ?? '-'}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          onClick={props?.handleCancel}
          type="default"
          style={{
            borderColor: "#004C8F",
            color: "#004C8F",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
        >
          NO
        </Button>
        <Button
          onClick={props?.handleSave}
          type="primary"
          style={{
            backgroundColor: "#004C8F",
            color: "#fff",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
          loading={props?.isLoading}
        >
          YES
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmSubmissionModalStage;
